<template>
	<div>
		<p class="text-center font-weight-medium mb-1">Recursos</p>
		<v-chip-group v-if="hayData" column class="centered-chips">
			<v-chip
				v-for="(documento, idx) in documentos"
				:key="'docs-' + idx"
				outlined
				color="blue"
				:href="`/api/Documentos/Descargar/${documento}?access_token=${token}`"
			>
				<v-icon left>mdi-file-outline</v-icon>
				{{ truncateElipsis(documento) }}
				<v-icon right size="18">mdi-download</v-icon>
			</v-chip>
			<v-chip
				v-for="(link, idx) in links"
				:key="'links-' + idx"
				outlined
				color="blue"
				:href="
					link.url.includes('http') ? link.url : `https://${link.url}`
				"
				target="_blank"
			>
				<v-icon left>mdi-link</v-icon>
				{{ truncateElipsis(link.titulo) }}
				<v-icon right size="18">mdi-open-in-new</v-icon>
			</v-chip>
		</v-chip-group>
		<p v-else class="text-center mb-1">N/A</p>
	</div>
</template>

<script>
import { mapState } from "vuex";
export default {
	props: {
		documentos: {
			type: Array,
			default: () => [],
		},
		links: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		...mapState(["token"]),
		hayData(){
			return this.documentos.length > 0 || this.links.length > 0;
		}
	},
	methods: {
		truncateElipsis(string, maxChars = 24){
          if (!string) return string;
          if (string.length <= maxChars) return string;
      
          const longitudPorcion = Math.floor((maxChars - 3) / 2);
      
          const inicio = string.slice(0, longitudPorcion);
          const fin = string.slice(-longitudPorcion);
      
          return inicio + "..." + fin;
        }
	},
};
</script>
<style scoped>
.centered-chips >>> .v-slide-group__content {
	justify-content: center;
}
</style>